import React from "react";
import Header from "./Header";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./Home";
import EntryPortal from "./EntryPortal";
import EntryAdmin from "./EntryAdmin";
import EntryActivity from "./EntryActivity";
import Login from "./Login";
import LoginFromGoogle from "./LoginFromGoogle";
import LoginFromGoogleRedirectToBackend from "./LoginFromGoogleRedirectToBackend";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import Preview from "./Preview";
import Accept from "./Accept";
import Setup from "./Setup";
import UserProfile from "./UserProfile";
import MyUserProfile from "./MyUserProfile";
import Users from "./Users";
import Portal from "./portal";
import Review from "./Review";
import ReadOnlyViewWrapper from "./ReadOnlyViewWrapper";
import Dashboard from "./Dashboard";
import ActivitiesList from "./ActivitiesList";
import DesignViewWrapper from "./DesignViewWrapper";
import RunActivityPage from "./runActivity";
import RequireAuth from "./RequireAuth";
import Admin from "./Admin";
import RequireAuthWithRole from "./RequireAuthWithRole";

const RoutesWithHeader = () => {
  const location = useLocation();
  const hideHeaderRoutes = ["/activities/run"];
  return (
    <>
      {!hideHeaderRoutes.includes(location.pathname) && <Header />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/entry/portal" element={<EntryPortal />} />
          <Route path="/entry/admin" element={<EntryAdmin />} />
          <Route path="/entry/activity" element={<EntryActivity />} />
          <Route path="/login" element={<Login />} />
          <Route path="/loginfromgoogle" element={<LoginFromGoogle />} />
          <Route
            path="/auth/google/callback"
            element={<LoginFromGoogleRedirectToBackend />}
          />
          <Route path="/register" element={<Register />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/passwordReset" element={<ResetPassword />} />
          <Route path="/preview" element={<Preview />} />
          <Route path="/readonly" element={<ReadOnlyViewWrapper />} />
          <Route path="/accept/:id" element={<Accept />} />
          <Route element={<RequireAuth />}>
            <Route path="/setup" element={<Setup />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/review" element={<Review />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/design" element={<DesignViewWrapper />} />
            <Route path="/profile" element={<MyUserProfile />} />
          </Route>
          <Route element={<RequireAuthWithRole role="sysadmin" />}>
            <Route path="/admin" element={<Admin />} />
            <Route path="/users/:id" element={<UserProfile />} />
            <Route path="/users" element={<Users />} />
            <Route path="/admin/activities" element={<ActivitiesList />} />
          </Route>
          <Route path="/activities/run" element={<RunActivityPage />} />
        </Routes>
      </main>
    </>
  );
};

export default RoutesWithHeader;
